module.exports = __webpack_public_path__ + "04_long_beige.41f2adc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/04_long_beige.png
// module id = Kjjk
// module chunks = 0